import React, { PureComponent } from 'react';
import { Currency } from '../../../../src/components/common/number'
import Text from '../../../../src/components/common/text';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import styles from './summary-cash-accounts.styles';
import SummaryCashAccountsGrid from './summary-cash-accounts-grid';
import { RefreshIcon, Info2 } from '@dbk/ui-icons';
import { PALETTE } from '../../../constants';
import { LoadingCircle } from '../../../components/common/loading';
import { Toast } from '@dbk/ui-notifications';
import Popover from '../../../components/popover-component';
class SummaryCashAccounts extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showCashAccBanner: false,
      sortedColumnIndex: -1,
      sortedDirection: 0,
    }
  }

  componentDidMount = async () => {
    await this.props.cashAccounts.setSpinner(false);
    await this.props.cashAccounts.setServerError(false);
    await this.props.cashAccounts.getRTCashAccList();
  }
  
  componentWillUnmount = async () => {
    await this.props.cashAccounts.setSpinner(false);
    await this.props.cashAccounts.setServerError(false);
  }
  
  async componentWillReceiveProps(nextProps) {
    this.setState({ showCashAccBanner: nextProps.cashAccounts.cashAccSummary ? nextProps.cashAccounts.cashAccSummary.hasMore : false });
    if (this.props.app.user.selectedPortfolioData.id !== nextProps.app.user.selectedPortfolioData.id) {
      this.setState({ sortedDirection: 0, sortedColumnIndex: -1 })
      await this.props.cashAccounts.getRTCashAccList();
    }
  }

  refreshClick = () => {
    this.props.cashAccounts.getRTCashAccList();
  }

  sortHandler = (sortedColumnIndex, sortedDirection) => {
    this.setState({
      sortedColumnIndex,
      sortedDirection
    })
  }

  render() {
    const { cashAccounts: { showSpinner, serverError, cashAccSummary, destinationCcy }, i18n: { messages }, languages: { destLanguage } } = this.props;
    if (serverError) {
      return (
        <div className="currencyChartNoData">
          <Text>{messages['app.rsa.serverError']}</Text>
        </div>
      );
    }
    else if (showSpinner || cashAccSummary === null || cashAccSummary === undefined)
      return <div className="portfolio-ldng-crcle"><LoadingCircle /></div>
    else if (cashAccSummary) {
      return (
        <div className="cash-container">
          {(!cashAccSummary.hasMore && cashAccSummary.cashAccList && cashAccSummary.cashAccList.length) ?
            <React.Fragment>
                <div className="mkt-val-refresh-icon">
                <div className="total-mkt-val-Qmark">
                  <Text type="primary" style={styles.marketValueLabel}>{messages['app.cashAccounts.label.totalMktValue']}</Text>
                  <Popover
                    mode="popup"
                    orientation="right"
                    showOnHover
                    popOverClassName="total-mkt-val-popover"
                    arrowColor={PALETTE.secondaryActive}
                    content={<div>{messages["app.cashAccounts.summary.totalMktValPopoverContent"]}</div>}
                  >
                    <Info2 className="cash-total-mkt-val-Qmark" color={PALETTE.fordGray} height={29} width={29}/>
                  </Popover>
                </div>
                <div className='cash-curr-refresh'>
                  <Currency
                    signBeforeNumber={false}
                    decimalStyle={styles.decimalStyle}
                    currencyStyle={styles.currencyStyle}
                    currency={destinationCcy}
                    renderProps={{
                      style: styles.marketValueText,
                      size: 40,
                      testID: 'market-value',
                    }}
                    value={cashAccSummary.totalMktVal}
                  />
                  <span onClick={this.refreshClick}>
                    <RefreshIcon className="pointer" id='refresh' width={30} height={30} color={PALETTE.secondaryActive} />
                  </span>
                </div>
              </div>
            </React.Fragment>
            : <div className='mktValHeight' />}
          {this.state.showCashAccBanner &&
            <Toast className="cashAccBanner" underline status="error" onClose={() => { this.setState({ showCashAccBanner: false }) }}>
              {messages["app.cashAccounts.cashSummaryDetails.exceedRecords"]}</Toast>}
          <SummaryCashAccountsGrid cashAccSummary={cashAccSummary}
            onSortChange={this.sortHandler} sortedColumnIndex={this.state.sortedColumnIndex} sortedDirection={this.state.sortedDirection}
            showCashAccBanner={this.state.showCashAccBanner} />
        </div>
      )
    }
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true
    },
    cashAccounts: {
      getRTCashAccList: { $call: 'getRTCashAccList' },
      cashAccSummary: true,
      showSpinner: true,
      setSpinner: { $set: 'showSpinner' },
      serverError: true,
      setServerError: { $set: 'serverError' },
      destinationCcy: true
    },
    app: {
      user: {
        selectedPortfolioData: true,
      }
    },
    languages: {
      destLanguage: true
    }
  }
})(SummaryCashAccounts);